export const CATEGORIES = {
  KITCHEN: "kitchen",
  BED_ROOM: "bedRoom",
  OFFICE: "office",
  DRESSING_ROOM: "dressingRoom",
  SCREEN_LIBRARY: "screenLibrary",
  BED: "bed",
  WALL_COVERING: "wallCovering",
  OTHER: "other",
}; 

export const CATEGORIES_ARABIC = {
  [CATEGORIES.KITCHEN]: "مطبخ",
  [CATEGORIES.BED_ROOM]: "غرفة نوم",
  [CATEGORIES.OFFICE]: "مكتب",
  [CATEGORIES.DRESSING_ROOM]: "غرفة ملابس (دريسنج)",
  [CATEGORIES.SCREEN_LIBRARY]: "مكتبة شاشة",
  [CATEGORIES.BED]: "سرير",
  [CATEGORIES.WALL_COVERING]: "تجليد حوائط",
  [CATEGORIES.OTHER]: "أخرى",
};